import { render, staticRenderFns } from "./HiredType.vue?vue&type=template&id=01a79b40&"
import script from "./HiredType.vue?vue&type=script&lang=js&"
export * from "./HiredType.vue?vue&type=script&lang=js&"
import style0 from "./HiredType.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports